export default __webpack_public_path__ + "static/media/SKRZYNIA.6784fbfc.png";